(function () {
  'use strict';

  function init(bar) {
    var sectionId = bar.dataset.sectionId;
    var target = document.getElementById(bar.dataset.targetId);
    if (!target) return;

    var footer = document.querySelector('footer');
    var stickySubmit = bar.querySelector('.maly-sticky-cart__submit');
    var stickySubmitText = stickySubmit && stickySubmit.querySelector('span');
    var stickyPrice = document.getElementById('StickyCartPrice-' + sectionId);
    var stickyImg = bar.querySelector('.maly-sticky-cart__media');
    var stickyQty = bar.querySelector('.maly-sticky-cart__qty-input');
    var realQtyInput = document.getElementById(bar.dataset.quantityId);

    var pastButton = false;
    var overFooter = false;

    function updateVisibility() {
      var visible = pastButton && !overFooter;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (visible && realQtyInput && stickyQty) {
        stickyQty.value = realQtyInput.value;
      }
    }

    // Affiche la barre une fois le bouton natif scrollé au-dessus du viewport,
    // la masque dès qu'il redevient visible (l'utilisateur remonte).
    var buttonObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          pastButton = false;
        } else if (entry.boundingClientRect.top < 0) {
          pastButton = true;
        }
        updateVisibility();
      });
    });
    buttonObserver.observe(target);

    // Masque la barre au-dessus du pied de page pour ne pas le chevaucher.
    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          overFooter = entry.isIntersecting;
          updateVisibility();
        });
      });
      footerObserver.observe(footer);
    }

    // Miroir de l'état du bouton natif (chargement, rupture de stock, libellé)
    // plutôt que de dupliquer la logique d'ajout au panier.
    var stickySpinner = stickySubmit && stickySubmit.querySelector('.loading__spinner');

    if (stickySubmit) {
      var syncSubmitState = function () {
        var isLoading = target.classList.contains('loading');
        stickySubmit.disabled = target.hasAttribute('disabled') || target.getAttribute('aria-disabled') === 'true';
        stickySubmit.classList.toggle('loading', isLoading);
        if (stickySpinner) stickySpinner.classList.toggle('hidden', !isLoading);
        var targetText = target.querySelector('span');
        if (targetText && stickySubmitText) stickySubmitText.textContent = targetText.textContent;
      };
      syncSubmitState();
      new MutationObserver(syncSubmitState).observe(target, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    // Prix + miniature : mis à jour via l'event global de changement de variante
    // (product-info.js), pour respecter la variante sélectionnée par le client.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || String(event.data.sectionId) !== String(sectionId)) return;

        if (stickyPrice && event.data.html) {
          var sourcePrice = event.data.html.getElementById('price-' + sectionId);
          if (sourcePrice) stickyPrice.innerHTML = sourcePrice.innerHTML;
        }
        if (stickyImg && event.data.variant && event.data.variant.featured_image) {
          stickyImg.src = event.data.variant.featured_image.src;
        }
      });
    }

    // Quantité : simple relais vers le vrai input du formulaire produit.
    if (stickyQty && realQtyInput) {
      stickyQty.addEventListener('change', function () {
        var value = parseInt(stickyQty.value, 10);
        if (!value || value < 1) value = 1;
        stickyQty.value = value;
        realQtyInput.value = value;
        realQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  document.querySelectorAll('[data-maly-sticky-cart]').forEach(init);
})();
